export default __webpack_public_path__ + "static/chocolateDelicious-7f506fcf11226d49f3228460687e69b0.png";